/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliParentDtoApiResponse } from '../../models/amoxcalli-parent-dto-api-response';
import { AmoxcalliRegisterParentDto } from '../../models/amoxcalli-register-parent-dto';

export interface ApiAuthRegisterParentPost$Plain$Params {
      body?: AmoxcalliRegisterParentDto
}

export function apiAuthRegisterParentPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAuthRegisterParentPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliParentDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAuthRegisterParentPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliParentDtoApiResponse>;
    })
  );
}

apiAuthRegisterParentPost$Plain.PATH = '/api/auth/register/parent';
